import { Button } from '@/components/ui/button';

interface ExpiredInvitationStateProps {
  isExpired: boolean;
  onNavigateToLogin: () => void;
}

export default function ExpiredInvitationState({ isExpired, onNavigateToLogin }: ExpiredInvitationStateProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-primary-50 dark:bg-primary-950 px-4">
      <div className="w-full max-w-md bg-white dark:bg-primary-900 border border-primary-200 dark:border-primary-800 p-8 text-center">
        <h1 className="text-2xl font-light tracking-tight text-primary-950 dark:text-white mb-4">
          {isExpired ? 'Convite Expirado' : 'Convite Já Utilizado'}
        </h1>
        <p className="text-primary-600 dark:text-primary-400 mb-6">
          {isExpired
            ? 'Este convite expirou. Por favor, entre em contato com o administrador para um novo convite.'
            : 'Este convite já foi aceito ou cancelado.'
          }
        </p>
        <Button onClick={onNavigateToLogin}>
          Ir para Login
        </Button>
      </div>
    </div>
  );
}
